export enum OnboardingStepStatus {
  ASSIGNED = 'ASSIGNED',
  COMPLETED = 'COMPLETED',
}

export enum OnboardingStep {
  REVIEW_ASSIGNMENT = 'REVIEW_ASSIGNMENT',
  REVIEW_SETTINGS = 'REVIEW_SETTINGS',
  SCHEDULE_ASSIGNMENT = 'SCHEDULE_ASSIGNMENT',
  UPLOAD_EMPLOYEES = 'UPLOAD_EMPLOYEES',
}

export interface IOnboardingStep {
  id: number;
  companyId: number;
  onboardingStep: OnboardingStep;
  stepNumber: number;
  status: OnboardingStepStatus;
}
